<template>
  <div class="loans-pro-item">
    <p class="title">{{ safeItem.title }}</p>
    <van-row>
      <van-col :span="8">
        <div class="lockming-pro-icon">
          <img :src="safeItem.img" />
        </div>
      </van-col>
      <van-col :span="16">
        <p class="desc">{{ $t("loans.orderno") }} : {{ safeItem.order_num }}</p>
        <p class="desc">
          {{ $t("lockming.stime") }} : {{ safeItem.start_time.split(" ")[0] }}
        </p>
        <p class="desc">
          {{ $t("lockming.etime") }} : {{ safeItem.end_time.split(" ")[0] }}
        </p>
        <p class="desc">
          {{ $t("lockming.nums") }} : {{ safeItem.amount.toFixed(8) }} {{ safeItem.coin }}
        </p>
        <p class="desc">
          {{ $t("lockming.estimation") }} :
          {{
            ((parseFloat(safeItem.amount) *
              parseFloat(safeItem.interest_rate) *
              parseFloat(safeItem.days)) /
            100).toFixed(8)
          }} {{ safeItem.coin }}
        </p>
        <p class="desc">
          {{ $t("lockming.real") }} : {{ safeItem.total_revenue.toFixed(8) }}
          {{ safeItem.coin }}
        </p>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  name: "LockmingOrder",
  props: ["item"],
  computed: {
    safeItem() {
      return this.item || {};
    },
  },
};
</script>

<style>
</style>
